import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=47ffd6d5"
import script from "@/views/modules/ReportAuths/js/ListView.js?vue&type=script&lang=js&external"
export * from "@/views/modules/ReportAuths/js/ListView.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports